import type { Directive } from 'vue'

interface HTMLElementWithClickOutside extends HTMLElement {
    clickOutsideEvent?: (event: Event) => void
}

export const clickOutside: Directive = {
    mounted(el: HTMLElementWithClickOutside, binding) {
        el.clickOutsideEvent = function(event: Event) {
            const target = event.target as Node

            if (!document.body.contains(target)) {
                return
            }

            const path = event.composedPath()

            if (el === target || el.contains(target) || path.includes(el)) {
                return
            }

            const isClickOnDropdown = Array.from(document.querySelectorAll('.app-select__dropdown')).some(
                dropdown => dropdown === target || dropdown.contains(target) || path.includes(dropdown)
            )

            if (isClickOnDropdown) {
                return
            }

            binding.value()
        }

        document.addEventListener('click', el.clickOutsideEvent, { capture: true })
    },
    unmounted(el: HTMLElementWithClickOutside) {
        if (el.clickOutsideEvent) {
            document.removeEventListener('click', el.clickOutsideEvent, { capture: true })
        }
    }
}
